export const GLOBAL_TIMEOUT_MS = 10000;

export const MAX_MONITORS_ALLOWED = 1;

export const VIRTUAL_WEBCAM_LABELS = [
  'obs',
  'virtual',
  'manycam',
  'snap camera',
  'xsplit',
  'splitcam',
  'droidcam',
  'epoccam',
  'iriun',
  'reincubate camo',
  'mmhmm',
  'ndi',
  'decklink',
  'elgato',
  'streamlabs',
  'nvidia broadcast',
  'amd link',
  'discord',
  'teams',
  'zoom',
];

export const GENERIC_DEVICE_ID_PATTERNS = [/^{[0-9A-F-]+}$/i];

export const SUSPICIOUS_PLUGIN_NAMES = [
  'cheat',
  'copy',
  'translate',
  'grammarly',
  'screenshot',
  'capture',
  'record',
  'spy',
];

export const EXTENSION_DOM_MARKERS = [
  '[data-gramm]',
  '[data-gramm_editor]',
  '[grammarly-extension]',
  '#__trancy-root',
  '[id*="cheat"]',
  '[class*="cheat"]',
  '[id*="helper-ext"]',
  '.gt_float_switcher',
];
